module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-gray-back"
  }, [_c('van-tabs', {
    staticClass: "coupon-nav",
    on: {
      "click": _vm.onTabChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "上架中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "已下架"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.onItemChange(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "sale-box",
      style: (_vm.check_index == index ? 'border:1px solid #ccc' : '')
    }, [_c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("套餐名称:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("活动时间:")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_c('p', [_vm._v("开始时间" + _vm._s(_vm._f("timeFormat")(item.time_start)))]), _vm._v(" "), _c('p', [_vm._v("结束时间" + _vm._s(_vm._f("timeFormat")(item.time_end)))])])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("购买/订单:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.order_count) + "/" + _vm._s(item.complete_count))])])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "closed": _vm.onClose,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('div', {
    staticClass: "add-b-b"
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "type": "info"
    },
    on: {
      "click": _vm.onSalesAdd
    }
  }, [_vm._v("新增销售单")])], 1)]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.share_show
    },
    on: {
      "click": function($event) {
        _vm.share_show = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper_b"
  }, [_c('img', {
    staticStyle: {
      "width": "5rem",
      "height": "5rem",
      "margin-bottom": "0.2rem"
    },
    attrs: {
      "src": _vm.share.pic_url,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.share.url),
      expression: "share.url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.share.url) + "\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.share.url),
      expression: "share.url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("点击链接复制")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba94872","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/configure/WyhConfigureList.vue
// module id = 2459
// module chunks = 0